import React from 'react';
import {useNavigate} from "react-router-dom";
import {useAuth} from "context/AuthContext";
import Dropdown, {DropdownItem} from "components/Dropdown";
import {EyeIcon, PencilIcon, TrashIcon} from "@heroicons/react/solid";
import {Exhibit} from "types/Exhibit";
import {EyeOffIcon} from "@heroicons/react/outline";

// Types ----

type ExhibitContextMenuProps = {
  exhibit: Exhibit
  onPublishExhibit: () => void
  onDeleteExhibit: () => void
  viewDisabled?: boolean
  editDisabled?: boolean
  publishDisabled?: boolean
  deleteDisabled?: boolean
  position?: 'left' | 'right'
}

// Component ----

function ExhibitContextMenu({
  deleteDisabled,
  onPublishExhibit,
  onDeleteExhibit,
  editDisabled,
  exhibit,
  viewDisabled,
  publishDisabled,
  position = 'right'
}: ExhibitContextMenuProps) {
  const navigate = useNavigate();
  const auth = useAuth();

  function viewExhibit() {
    void navigate(`/exhibits/${exhibit.id}`)
  }

  function editExhibit() {
    void navigate(`/exhibits/${exhibit.id}/edit`)
  }

  return (
    <Dropdown position={position}>
      {auth.can('exhibits:read') &&
        <DropdownItem
          name="View"
          icon={EyeIcon}
          onClick={viewExhibit}
          disabled={!!viewDisabled}
        />
      }

      {auth.can('exhibits:write') &&
        <DropdownItem
          name="Edit"
          icon={PencilIcon}
          onClick={editExhibit}
          disabled={!!editDisabled}
        />
      }

      {(auth.can('exhibits:write') || auth.can('exhibits:publish')) &&
        <DropdownItem
          name={`${exhibit.is_published ? 'Hide' : 'Publish'}`}
          icon={exhibit.is_published ? EyeOffIcon : EyeIcon}
          onClick={onPublishExhibit}
          disabled={!!publishDisabled}
        />
      }

      {auth.can('exhibits:write') &&
        <DropdownItem
          name="Delete"
          icon={TrashIcon}
          onClick={onDeleteExhibit}
          disabled={!!deleteDisabled}
        />
      }
    </Dropdown>
  );
}

export default ExhibitContextMenu;